import Vue from 'vue';
import Vuex from 'vuex';
import { AuxData, State, VehiclesNormalizedData, VehiclesStringData } from '@/types/vuex/state';
import { Store } from '@/types/vuex/store';
import { mutations } from '@/store/mutations';
import { actions } from '@/store/actions';
import { getters } from '@/store/getters';
import { PhoneButtons } from '@/types/api';

Vue.use(Vuex);

export const COMPARING_ITEMS_AMOUNT = 3;

export const state: State & VehiclesNormalizedData = {
    itemsPerPage: 0,
    checkIfNeedToLoadMoreItems: false,
    isComparing: false,
    items: [],
    listCache: {},
    comparisonCache: {},
    shortInfo: [],
    tickedItems: [0, 0, 0],
    comparingItemInitialized: false,
    menuSellerOpened: false,
    menuTechSpecOpened: false,
    emptyContentDivId: '',
    apiUrl: '',
    auxData: {} as AuxData,
    isComparisonLoading: true,
    isListLoading: true,
    isNewListPageLoading: false,
    fetchingVehicleData: [false, false, false],
    error: false,
    isDisplayingDifference: false,
    modal: {
        isOpened: false,
        id: '',
        src: ''
    },
    deleteCarModal: {
        isOpened: false,
        index: 0
    },
    includedOptionsModal: {
        isOpened: false,
        index: 0
    },
    isMobile: false,
    whatsappHint: '',
    comparingItemsFromBackend: null,
    isEmptyTechSpec: false,
    photos: ['', '', ''],
    years: ['', '', ''],
    makes: ['', '', ''],
    models: ['', '', ''],
    variants: ['', '', ''],
    prices: ['', '', ''],
    tradePrice: ['', '', ''],
    vats: ['', '', ''],
    onos: ['', '', ''],
    mileages: ['', '', ''],
    colors: ['', '', ''],
    fuelTypes: ['', '', ''],
    transmissions: ['', '', ''],
    doors: ['', '', ''],
    bodyStyles: ['', '', ''],
    engineSizes: ['', '', ''],
    standardTaxes: ['', '', ''],
    standardTaxCallouts: ['', '', ''],
    additionalTaxes: ['', '', ''],
    additionalTaxCallouts: ['', '', ''],
    warranties: ['', '', ''],
    insurances: ['', '', ''],
    insurancesCallouts: ['', '', ''],
    insurancesLinks: ['', '', ''],
    approvalSchemeLinks: ['', '', ''],
    approvalSchemeNames: ['', '', ''],
    approvalSchemeLogos: ['', '', ''],
    isVan: ['', '', ''],
    owners: ['', '', ''],
    stolen: ['', '', ''],
    stolenCallouts: ['', '', ''],
    scrapped: ['', '', ''],
    scrappedCallouts: ['', '', ''],
    writeOff: ['', '', ''],
    writeOffCallouts: ['', '', ''],
    hpiHistoryLink: ['', '', ''],
    expertReviewLinks: ['', '', ''],
    customerReviewLinks: ['', '', ''],
    expertRatings: ['', '', ''],
    customerRatings: ['', '', ''],
    enginePower: ['', '', ''],
    acceleration: ['', '', ''],
    topSpeed: ['', '', ''],
    fuelConsumption: ['', '', ''],
    fuelTankCapacity: ['', '', ''],
    combinedRange: ['', '', ''],
    co2Emissions: ['', '', ''],
    numberOfSeats: ['', '', ''],
    length: ['', '', ''],
    width: ['', '', ''],
    height: ['', '', ''],
    weight: ['', '', ''],
    luggage: ['', '', ''],
    wheelType: ['', '', ''],
    loadHeight: ['', '', ''],
    loadLength: ['', '', ''],
    payload: ['', '', ''],
    towingWeight: ['', '', ''],
    sellers: ['', '', ''],
    sellerLogos: ['', '', ''],
    dealerRatings: ['', '', ''],
    dealerReviewLinks: ['', '', ''],
    dealerReviewCounts: ['', '', ''],
    addresses: ['', '', ''],
    townes: ['', '', ''],
    postcodes: ['', '', ''],
    mapsLinks: ['', '', ''],
    emailEnquiryLinks: ['', '', ''],
    pxEnquiryLinks: ['', '', ''],
    testDriveLinks: ['', '', ''],
    phones: ['', '', ''],
    phoneButtons: [{}, {}, {}] as [PhoneButtons, PhoneButtons, PhoneButtons],
    ownerIds: ['', '', ''],
    smsMessages: ['', '', ''],
    facebookIds: ['', '', ''],
    isOpened: ['', '', ''],
    urls: ['', '', ''],
    hasIncludedOptions: [false, false, false],
    tradeRegDate: ['', '', ''],
    tradeKeys: ['', '', ''],
    tradeTaxBook: ['', '', ''],
    includedOptionsCache: {} as VehiclesStringData
};

const store = new Vuex.Store({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
    modules: {}
});

export function useStore () {
    return store as Store;
}
